export const MAPPED_ENDPOINTS = {
    postalCodeValidate: "postalCode/validate"
};

export function buildPathToApi(endpoint: string) {
    const asaasPath = window.location.origin || "https://www.asaas.com";

    return `${asaasPath}/${endpoint}`;
}
